export const UPDATE_EMAIL_SETTINGS_REQUEST = 'UPDATE_EMAIL_SETTINGS_REQUEST';
export const UPDATE_EMAIL_SETTINGS_SUCCESS = 'UPDATE_EMAIL_SETTINGS_SUCCESS';
export const UPDATE_EMAIL_SETTINGS_FAILURE = 'UPDATE_EMAIL_SETTINGS_FAILURE';
